import Axios from "axios";
import Firebase from "firebase";
import moment from "moment";
import store from "../store";

const AdminTrainingInfoStore = {
  namespaced: true,
  debug: true,
  state: {
    adminLatestSchedule: [],
    adminScheduleList: [],
    adminScheduleDetail: {},
    adminTrainingList: [],
    adminTrainingMaster: {}
  },
  mutations: {
    setAdminLatestSchedule(state, data) {
      state.adminLatestSchedule = data;
    },
    setAdminScheduleList(state, data) {
      state.adminScheduleList = data;
    },
    setAdminScheduleDetail(state, data) {
      state.adminScheduleDetail = data;
    },
    setAdminTrainingList(state, data) {
      state.adminTrainingList = data;
    },
    setAdminTrainingMaster(state, data) {
      state.adminTrainingMaster = data;
    }
  },
  getters: {
    getAdminLatestSchedule(state) {
      return state.adminLatestSchedule.map(val => {
        let result = {
          schedulenumber: val.schedulenumber,
          day: moment(val.startdate).format("YYYY/MM/DD"),
          startTime: moment(val.startdate).format("Ah:mm 開始"),
          type:
            val.type != null && val.type != ""
              ? store.getters[
                  "constantStore/constant/constantStore/getTypeData"
                ](val.type).label
              : "",
          people: val.reservationcount + " of " + val.capacity
        };
        return result;
      });
    },
    getAdminScheduleList(state) {
      return state.adminScheduleList.map(val => {
        let result = {
          schedulenumber: val.schedulenumber,
          day: moment(val.startdate).format("YYYY/MM/DD"),
          startTime: moment(val.startdate).format("Ah:mm 開始"),
          type:
            val.type != null && val.type != ""
              ? store.getters[
                  "constantStore/constant/constantStore/getTypeData"
                ](val.type).label
              : "",
          people: val.reservationcount + " of " + val.capacity
        };
        return result;
      });
    },
    getAdminScheduleDetail(state) {
      let result = state.adminScheduleDetail;
      result.startdate = moment(state.adminScheduleDetail.startdate).format(
        "HH:mm"
      );
      result.enddate = moment(result.enddate).format("HH:mm");
      result.date = moment(state.adminScheduleDetail.targetdate).format(
        "YYYY-MM-DD"
      );
      result.type =
        state.adminScheduleDetail.type != null
          ? store.getters["constantStore/constant/constantStore/getTypeData"](
              state.adminScheduleDetail.type
            )
          : "";
      result.capacity = state.adminScheduleDetail.capacity;
      result.reservationcount = state.adminScheduleDetail.reservationcount;
      result.reservations = result.reservationcount + " of " + result.capacity;
      result.noreservation = state.adminScheduleDetail.noreservation;
      return result;
    },
    getAdminTrainingList(state) {
      return state.adminTrainingList.map(val => {
        let result = {
          trainingmasternumber: val.trainingmasternumber,
          type:
            val.type != null && val.type != ""
              ? store.getters[
                  "constantStore/constant/constantStore/getTypeData"
                ](val.type).label
              : ""
        };
        return result;
      });
    },
    getAdminTrainingMaster(state) {
      let result = state.adminTrainingMaster;
      result.targetdate = moment(state.adminTrainingMaster.targetdate).format(
        "YYYY-MM-DD"
      );
      result.type =
        state.adminTrainingMaster.type != null
          ? store.getters["constantStore/constant/constantStore/getTypeData"](
              state.adminTrainingMaster.type
            )
          : "";
      return result;
    }
  },
  actions: {
    async callApiAdminLatestSchedule({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let latestSchedule = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/schelduelListAfterNow",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setAdminLatestSchedule", latestSchedule.data);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiAdminScheduleList({ commit }, targetdate) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let adminScheduleList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/scheduleList",
            {
              searchDate: targetdate
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setAdminScheduleList", adminScheduleList.data);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiAdminScheduleDetail({ commit }, scheduleNumber) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let adminScheduleDetail = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/scheduleDetail",
            {
              scheduleNumber: scheduleNumber
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setAdminScheduleDetail", adminScheduleDetail.data[0]);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiAdminTrainingList({ commit }, targetDate) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let adminTrainingList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/trainingList",
            {
              targetDate: targetDate
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setAdminTrainingList", adminTrainingList.data);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiAdminTrainingMaster({ commit }, trainingmasternumber) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let adminTrainingMaster = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/trainingMaster",
            {
              trainingmasternumber: trainingmasternumber
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setAdminTrainingMaster", adminTrainingMaster.data[0]);
        })
        .catch(function() {
          // Handle error
        });
    }
  }
};
export default AdminTrainingInfoStore;
